// sagas/fiuSaga.ts
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { PayloadAction } from '@reduxjs/toolkit';
import { goalActions as actions } from '.';
import { authenticatedPost, authenticatedPut, get } from 'remote/api';

function* createGoalSaga(action: PayloadAction<any>) {
  try {
    const { id, metadata } = action.payload;
    const method = id ? authenticatedPut : authenticatedPost;
    const url = id
      ? `${process.env.REACT_APP_API_URL}/goals/${id}`
      : `${process.env.REACT_APP_API_URL}/goals/`;
    const data = id ? metadata : action.payload;
    const response = yield call(method, url, data);
    yield put(actions.createGoalSuccess(response.data));
  } catch (error: any) {
    yield put(actions.creatGoalFailure(error.message));
  }
}
function* getGoalDataSaga(action: PayloadAction<any>) {
  try {
    const response = yield call(
      get,
      `${process.env.REACT_APP_API_URL}/goals/goaldata/${action.payload}`,
    );
    yield put(actions.getGoalDataSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getGoalDataFailure(error.message));
  }
}

export function* goalSaga() {
  yield all([
    takeLatest(actions.createGoal.type, createGoalSaga),
    takeLatest(actions.getGoalData.type, getGoalDataSaga),
  ]);
}
